import styled from 'styled-components';
import { ContentSpacing, breakpoint, Colors } from '@estee/elc-base-theme';
import { cartItemActionLinkTheme } from '~theme/default-theme';
import { StyledButton } from '~views/Collection/CollectionStyles';

const { space4, space8, space16, space12, space24 } = ContentSpacing;

export const CartItemPanel = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: nowrap;
    flex-direction: row;
    min-height: 112px;
    border-bottom: 1px solid ${Colors.primary300};
    padding: ${space8} ${space16} ${space12} ${space16};

    ${breakpoint('desktop')`
        padding: ${space24};
    `};
`;

export const DetailsWrapper = styled.div`
    width: 70%;
    display: flex;
    flex-direction: column;

    [dir='rtl'] & {
        padding: ${space4} ${space4} 0 0;
    }
`;

export const DescriptionWrapper = styled.div`
    display: flex;
    flex-direction: row;
`;

export const SaveForLaterActionLink = styled.a`
    cursor: pointer;
    padding-top: ${space12};
    ${breakpoint('desktop')`
        display: block;
    `};
    ${cartItemActionLinkTheme};
`;

export const StyledDetailsWrapper = styled(DetailsWrapper)`
    width: 70%;
`;

export const StyledButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-start;
`;

export const RemoveLabel = styled(StyledButton)`
    margin-right: ${space8};
`;

export const StyledCartItemAlert = styled.div`
    display: flex;
    padding: 12px;
    margin-block-start: 21px;
`;

export const StyledCartItemAlertDetails = styled.div`
    padding: 0 10px;
`;
